<!-- Базовый шаблон вложенной таблицы -->
<template>
    <div>
        <b-table
            striped
            hover
            bordered
            head-variant="light"
            :items="items"
            :fields="fields"
            :busy="busy"
            v-model="visibleRows"
        >
            <template #cell()="data">
                <base-cell :is-detailable="false" :data="data" />
            </template>

            <template v-slot:table-busy>
                <b-spinner />
            </template>
        </b-table>
        <b-alert :show="loadFail" variant="danger">
            Loading failed. Please try again.
        </b-alert>
    </div>
</template>

<script>
import Vue from 'vue';

import BaseCell from '@/components/Table/BaseCell.vue';

export default Vue.extend({
    name: 'BaseSubTable',
    components: {
        BaseCell
    },
    props: {
        /** Набор значений */
        items: {
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
        /** Описание полей */
        fields: {
            type: Array,
            required: false,
            default: function() {
                return [];
            }
        },
        /** флаг загрузки */
        busy: {
            type: Boolean,
            required: false,
            default: false
        },
        /** флаг неудачной загрузки */
        loadFail: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return {
            visibleRows: [],
        };
    }
});
</script>
